import { Resource } from "nova_ecs/resource";

export const SystemIdResource = new Resource<string>('SystemIdResource');
